export default __webpack_public_path__ + "static/media/by.5135fe3e.svg";